import apiClient from '../apiClient';
import { PUT_PAYMENT_SCHEME_DETAIL_URL } from '../apiUrl';

const putPaymentSchemeDetailApi = (id, data) => {
  return apiClient.put(PUT_PAYMENT_SCHEME_DETAIL_URL(id), data);
};

export default putPaymentSchemeDetailApi;
